module.exports = __webpack_public_path__ + "email@2x.ae66689491751f3e596574066e6618e8.png";